export function findAvailableUpgrades(id, model) {
  return { path: `${model}/${id}/available_upgrades` };
}

export function getBuildingUpgrades(buildingId) {
  return { path: `buildings/${buildingId}/upgrades` };
}

export function getAddableUpgrades(buildingId) {
  return {
    path: `buildings/${buildingId}/addable_upgrades`,
  };
}

export function addUpgradeToBuilding(buildingId, planId) {
  return {
    path: 'property_plans',
    method: 'POST',
    body: JSON.stringify({
      property_id: buildingId,
      plan_id: planId,
    }),
  };
}

export function removeUpgradeFromBuilding(propertyPlanId) {
  return {
    path: `property_plans/${propertyPlanId}`,
    method: 'DELETE',
  };
}

export function searchUpgrades(search, contentType) {
  return {
    path: `plan${search.replace('product_id=all', '')}`,
    accept: contentType,
  };
}

export function getUpgrade(planId) {
  return { path: `plan/${planId}` };
}

export function createUpgrade(productId, amount) {
  return {
    path: 'plan',
    method: 'POST',
    body: JSON.stringify({
      product_id: productId,
      // Default to 1 month interval until table/option is removed
      interval_id: 1,
      amount,
    }),
  };
}

export function deleteUpgrade(planId) {
  return {
    path: `plan/${planId}`,
    method: 'DELETE',
  };
}

export function searchProducts(search) {
  return { path: `products${search}` };
}

export function getProducts(productId) {
  return {
    path: `products/${productId}`,
  };
}
